import { useMemo } from 'react';

import { DEFAULT_AGENT_TIME_RANGE } from '../constants';

type UseHasActiveFiltersParams = {
  pipelineName: string;
  agentName: string;
  content: string;
  time: string;
};

export function useHasActiveFilters({
  pipelineName,
  agentName,
  content,
  time
}: UseHasActiveFiltersParams): boolean {
  return useMemo(
    () =>
      Boolean(
        pipelineName ||
        agentName ||
        content ||
        (time && time !== DEFAULT_AGENT_TIME_RANGE)
      ),
    [pipelineName, agentName, content, time]
  );
}
